/**
 * ゲーム進捗データ
 *
 * 挑戦モードのクリア状態を管理する。
 */
export interface GameProgress {
  /** クリア済みステージ数（0〜9） */
  clearedStages: number;
  /** ボス撃破済みのキャラIDリスト */
  bossDefeatedWith: string[];
  /** 解放済み隠しキャラIDリスト */
  unlockedHiddenMonsters: string[];
  /** 熟練以上の大会で優勝済みか（アリス解放条件） */
  tournamentWonAtShukuren: boolean;
  /** 難易度不問で大会優勝済みか（アリスヒント表示条件） */
  anyTournamentWon: boolean;
}

/** デフォルトのゲーム進捗（未クリア状態） */
export const DEFAULT_GAME_PROGRESS: GameProgress = {
  clearedStages: 0,
  bossDefeatedWith: [],
  unlockedHiddenMonsters: [],
  tournamentWonAtShukuren: false,
  anyTournamentWon: false,
};

/**
 * GameProgress型のバリデーション
 */
export function isValidGameProgress(obj: unknown): obj is GameProgress {
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return false;
  }

  const candidate = obj as Record<string, unknown>;

  return (
    typeof candidate.clearedStages === 'number' &&
    Number.isInteger(candidate.clearedStages) &&
    candidate.clearedStages >= 0 &&
    candidate.clearedStages <= 9 &&
    (candidate.bossDefeatedWith === undefined || Array.isArray(candidate.bossDefeatedWith))
  );
  // unlockedHiddenMonsters / tournamentWonAtShukuren は後方互換のため省略可（loadGameProgressで補完）
}
